import { render, staticRenderFns } from "./CustomizeDashboard.vue?vue&type=template&id=18b435ea&scoped=true"
import script from "./CustomizeDashboard.vue?vue&type=script&lang=js"
export * from "./CustomizeDashboard.vue?vue&type=script&lang=js"
import style0 from "./CustomizeDashboard.vue?vue&type=style&index=0&id=18b435ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b435ea",
  null
  
)

export default component.exports